import {BlobGenerator} from "./blob";
import {PARTS} from "./types";
import {AvatarConfig} from "../types";
import {lightGray} from "../../shared/colors";

const SVGFilter = `<defs>
  <filter id="filter" x="-20%" y="-20%" width="140%" height="140%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="linearRGB">
    <feMorphology operator="dilate" radius="20 20" in="SourceAlpha" result="morphology"/>
    <feFlood flood-color="#ffffff" flood-opacity="1" result="flood"/>
    <feComposite in="flood" in2="morphology" operator="in" result="composite"/>
    <feMerge result="merge">
          <feMergeNode in="composite" result="mergeNode"/>
      <feMergeNode in="SourceGraphic" result="mergeNode1"/>
      </feMerge>
  </filter>
</defs>`;

export class Avatar {

  static async generateRandom(color: string, flip?: boolean): Promise<string> {
    const ids = new Map<string, string>();
    PARTS.forEach(part => {
      if (part.id === "face") {
        return;
      }
      if (part.id === "glasses") {
        if (Math.random() < 0.8) {
          return;
        }
      }
      ids.set(part.id, "" + Math.floor(Math.random() * part.count));
    });
    ids.set("accessories", "0");
    ids.set("details", "0");
    ids.set("beard", "0");
    return this.generatePreview(ids, color, flip);
  }

  static async generateImageDataUrl(config: AvatarConfig, color?: string, flip?: boolean): Promise<string> {
    const svg = await this.generatePreviewFromConfig(config, color, flip);
    const header = 'data:image/svg+xml;base64,';
    return header + btoa(svg);
  }

  static async generatePreviewFromConfig(config: AvatarConfig, color?: string, flip?: boolean): Promise<string> {
    const ids = new Map<string, string>();
    PARTS.forEach(part => {
      if (part.id === "face") {
        return;
      }
      const value = config.parts.find(configPart => part.id === configPart.id)?.value || 0;
      ids.set(part.id, value.toString());
    });
    return this.generatePreview(ids, color || config.color || lightGray, flip || config.flip, config.blobSeed);
  }

  static async generatePreview(partsSelected: Map<string, string>, color: string, flip: boolean = false, blobSeed: number = 0): Promise<string> {
    const groups: string[] = [];
    groups.push(BlobGenerator.create(color, 1080, 0.9, 0.4, 6, blobSeed !== 0 ? blobSeed : Math.floor(Math.random() * 1000000)));
    groups.push(...(await Promise.all(
      PARTS.map(async (type) => {
        /* eslint-disable */
        const selected = partsSelected.get(type.id);
        if (!selected) {
          return '';
        }
        const url = `/assets/preview/${type.id}/${selected}.svg`;
        const svgRaw = await fetch(url).then(res => res.text());
        return `\n<g ${
          type.id === 'face' ? 'fill="#ffffff"' : ''
        } ${flip ? 'transform="scale(-1,1) translate(-1080, 0)"' : ''}>\n
      ${svgRaw.replace(/<svg.*(?=>)>/, '').replace('</svg>', '')}
    \n</g>\n`;
      }),
    )));

    const previewSvg =
      `<svg viewBox="0 0 1080 1080" fill="none" xmlns="http://www.w3.org/2000/svg">
        ${SVGFilter}
      <g filter="url(#filter)">
        ${groups.join('\n\n')}
      </g>
      </svg>`
        .trim()
        .replace(/(\n|\t)/g, '')
        .replaceAll("<?xml version=\"1.0\" encoding=\"UTF-8\"?>", "");

    return previewSvg;
  };
}